import { defineAsyncComponent } from 'vue';

const TACircularVATDeclarationDetail = defineAsyncComponent(() =>
  import('@/views/tax/tACircularVAT/TACircularVATDeclarationDetail.vue')
);

const TACircularVATDeclarationDirectDetail = defineAsyncComponent(() =>
  import('@/views/tax/tACircularVAT/TACircularVATDeclarationDirectDetail.vue')
);

const TAEnterpriseIncomeTaxDetail = defineAsyncComponent(() =>
  import('@/views/tax/tAEnterpriseIncomeTax/TAEnterpriseIncomeTaxDetail.vue')
);

// form thông báo xóa lỗi
const DeleteTACircularErrorPopup = defineAsyncComponent(() =>
  import('@/views/tax/tACircularVAT/DeleteTACircularErrorPopup.vue')
);

// form thông báo xóa lỗi
const TAPurchaseSaleInvalidate = defineAsyncComponent(() =>
  import('@/views/tax/tACircularVAT/TAPurchaseSaleInvalidate.vue')
);
const ChoosePurchaseSalePopup = defineAsyncComponent(() =>
  import('@/views/tax/tACircularVAT/ChoosePurchaseSalePopup.vue')
);

// Đăng kí popup nộp thuế GTGT (NHANH3 4.1.2022)
const TAPayTax = defineAsyncComponent(() => import('@/views/tax/tAPayTax/TAPayTax.vue'));

const TaxDeductDetail = defineAsyncComponent(() => import('@/views/tax/taxdeduct/TaxDeductDetail.vue'));

// form tham số thêm mới
const ChooseCircularVATDeclaration = defineAsyncComponent(() =>
  import('@/views/tax/tACircularVAT/ChooseCircularVATDeclaration.vue')
);
// form tham số thêm mới theo pp tính trực tiếp
const ChooseCircularVATDeclarationDirect = defineAsyncComponent(() =>
  import('@/views/tax/tACircularVAT/ChooseCircularVATDeclarationDirect.vue')
);

// Form danh sách hóa đơn phát sinh
const TARiskCustomerVendorDetail = defineAsyncComponent(() =>
  import('@/views/tax/tARiskCustomerVendor/TARiskCustomerVendorDetail.vue')
);

// Form danh sách hóa đơn phát sinh
const TACompanyNotActiveOrRiskDetail = defineAsyncComponent(() =>
  import('@/views/tax/tACircularVAT/TACompanyNotActiveOrRiskDetail.vue')
);

// Form hiển thị công văn số 1798
const TADocumentPopup = defineAsyncComponent(() =>
  import('@/views/tax/tARiskCustomerVendor/TADocumentPopup.vue')
);

// Form danh sách hóa đơn phát sinh
const TARiskCustomerVendorInfoDetail = defineAsyncComponent(() =>
  import('@/views/tax/tARiskCustomerVendor/TARiskCustomerVendorInfoDetail.vue')
);

// form tham số thêm mới tờ khai thuế thu nhập doanh nghiệp (NHANH3 28.03.2024)
const ChooseEnterpriseIncomeTax = defineAsyncComponent(() =>
  import('@/views/tax/tAEnterpriseIncomeTax/ChooseEnterpriseIncomeTax.vue')
);


export function registerTA(app) {
  app.component('TACircularVATDeclarationDetail', TACircularVATDeclarationDetail);
  app.component('TACircularVATDeclarationDirectDetail', TACircularVATDeclarationDirectDetail);
  app.component('TAEnterpriseIncomeTaxDetail', TAEnterpriseIncomeTaxDetail);
  app.component('DeleteTACircularErrorPopup', DeleteTACircularErrorPopup);
  app.component('TAPayTax', TAPayTax);
  app.component('TaxDeductDetail', TaxDeductDetail);
  app.component('ChooseEnterpriseIncomeTax', ChooseEnterpriseIncomeTax);
  app.component('ChooseCircularVATDeclaration', ChooseCircularVATDeclaration);
  app.component('ChooseCircularVATDeclarationDirect', ChooseCircularVATDeclarationDirect);
  app.component('TAPurchaseSaleInvalidate', TAPurchaseSaleInvalidate);
  app.component('ChoosePurchaseSalePopup', ChoosePurchaseSalePopup);
  app.component('TARiskCustomerVendorDetail', TARiskCustomerVendorDetail);
  app.component('TACompanyNotActiveOrRiskDetail', TACompanyNotActiveOrRiskDetail);
  app.component('TADocumentPopup', TADocumentPopup);
  app.component('TARiskCustomerVendorInfoDetail', TARiskCustomerVendorInfoDetail);
}
